import React from 'react';
import Bunny from './Bunny';

const FileUpload = (props) => {
  return <Bunny {...props} />;
};

export default FileUpload;
